import MedicareTotals from "./MedicareTotals";

export default MedicareTotals;